<template>
	<div class="body">
		<div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box about-us">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>American Credit's<br>background</h1> -->
							<h1>Who we are & what we stand for</h1>
							<br />
							<button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Try us now. See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="about-us-main-img" src="../assets/imgs/American_Credit_About_Us.png" alt="American Credit About Us"/>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%;">
			<div class="row platform-for-success">
				<div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
				<div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
				<div class="container platform-for-success-content">
					<div class="row">
						<div class="col-12 col-lg-10 offset-lg-1">
							<h2 class="text-left">A platform for success whatever your business</h2>
							<div class="row text-left">
								<div class="col-12 col-lg-4 pt-2">
									<div class="platform-for-success-card"> 
										<div class="image-container">
											<img src="../assets/imgs/American_Credit_Platform_for_Success_Whatever_Your_Business.png" alt="American Credit Platform for Success Whatever Your Business">
										</div>
										<br>
										<p class="platform-for-success-text">Whether you have a construction company, used car dealership, dental office, welding shop</p>
										<br />
										<div class="hover-element">
											<p><span class="platform-for-success-read-more"><a>Read more <i class="fa fa-chevron-right" style="color: #5456ff;"></i></a></span></p>
											<p class="hover-display-content">or virtually any other business, we support you in spirit and practice. Our platform evaluates your business based on its real-life performance, not just your credit score—enabling us to offer you funding on a responsible basis at reasonable terms.</p>
										</div>
									</div>
								</div> 
								<div class="col-12 col-lg-4 pt-2">
									<div class="platform-for-success-card"> 
										<div class="image-container">
											<img style="height: 100%; width: auto; object-fit: contain;" src="../assets/imgs/American_Credit_Platform_for_Success_Most_Profitable.png" alt="American Credit Platform for Success Most Profitable">
										</div>
										<br>
										<p class="platform-for-success-text">We want you to be able to devote time to where it's most profitable</p>
										<br />
										<div class="hover-element">
											<p><span class="platform-for-success-read-more"><a>Read more <i class="fa fa-chevron-right" style="color: #5456ff;"></i></a></span></p>
											<p class="hover-display-content">running your business and serving your clientele—instead of chasing business financing. And from the moment you apply for a loan to the end of its term, your American Credit personal assistant is available to support you.</p>
										</div>
									</div>
								</div>  
								<div class="col-12 col-lg-4 pt-2">
									<div class="platform-for-success-card"> 
										<div class="image-container">
											<img style="height: 100%; width: auto; object-fit: contain;" src="../assets/imgs/American_Credit_Platform_for_Sucess_Credit_Score_OK.png" alt="American Credit Platform for Sucess Credit Score OK">
										</div>
										<br>
										<p class="platform-for-success-text">And remember, a less-than-prime credit score is OK.</p>
										<br />
										<div class="hover-element">
											<p><span class="platform-for-success-read-more"><a>Read more <i class="fa fa-chevron-right" style="color: #5456ff;"></i></a></span></p>
											<p class="hover-display-content">The American Credit lending platform allows us take into account more than your credit score. Which means a moderate score doesn’t disqualify you for an American Credit asset backed loan. See what you can borrow.</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%; background: white;">
			<div class="container platform trust-us about-us-simple-idea">
				<div class="row trust-us-box">
					<div class="col-12 col-lg-5 offset-lg-1 trust-us-inner-left">
						<div>
							<p class="trust-us-title">Secured loans take up about 1/5 of the size of GDP<sup>1</sup>. We are a dedicated fintech platform for secured loans.</p>
							<p class="trust-us-text"><span style="color: #686868; font-weight: 300;">We started with a simple idea: the secured loan market has to keep pace with the digital age. We believe that small and medium businesses shouldn’t be deprived of the opportunity to enjoy the benefit of a fintech revolution to fuel their companies.</span></p>
							<br />
							<div class="trust-us-button">
								<button @click="this.window.location.href='/get-start'">Apply Now</button>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-5 trust-us-inner-right">
						<img src="../assets/imgs/American_Credit_About_Us_Simple_Idea.png" alt="American Credit About Us Simple Idea"/>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%;">
      <div class="row user-feedback">
        <div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
        <div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
        <div class="container row user-feedback-content">
          <div class="col-12 col-lg-5 offset-lg-1 user-feedback-content-left">
            <img src="../assets/imgs/American_Credit_Team_Customer_Voice.png" alt="American Credit Team Customer Voice"/>
          </div>
          <div class="col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right">
            <img src="../assets/imgs/quote.png" alt="American Credit Team Customer Voice Quote">
            <p class="user-feedback-text">I need to spend my time meeting customers’ expectations, not on lengthy loan applications.</p>
            <br>
            <br>
            <p  class="user-feedback-name"><span style="color: #6d6d6d; font-weight: 300;">Laurie Townsend</span><br><span style="color: #3c3c3c; font-weight: 700;">Account Receivable Manager, Lone Star Uniform Services</span></p>
            <div class="user-feedback-button">
              <button @click="this.window.location.href='tel:1855-904-0188'">Let’s Talk</button>
              <p><span style="color: #3c3c3c; font-weight: 300;">Try us now. </span><span style="color: #3c3c3c; font-weight: 700;">See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

		<div style="width: 100%; background: white;">
			<div class="container platform meet-founding-team">
				<div class="row meet-founding-team-box">
					<div class="col-12 col-lg-5 offset-lg-1 meet-founding-team-inner-left">
						<img style="margin-bottom: 18px;" src="../assets/imgs/quote.png" alt="American Credit Business Loans Meet Founding Team Quote">
            <p class="user-feedback-text">The dilemma in the current equipment financing market: often financing & purchases are bundled. American Credit’s dedicated fintech platform for secured loans is a solution to that problem.</p>
            <br>
            <p  class="user-feedback-name"><span style="color: #6d6d6d; font-weight: 700;">Dr. Lei Li</span><br><span style="color: #3c3c3c; font-weight: 700;">American Credit Founder</span></p>
            <div class="user-feedback-button">
              <button @click="this.window.location.href='tel:1855-904-0188'">Let’s Talk</button>
              <p><span style="color: #3c3c3c; font-weight: 300; margin-left: 15px;">Meet the founding team. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
            </div>
					</div>
					<div class="col-12 col-lg-5 meet-founding-team-inner-right">
						<img src="../assets/imgs/American_Credit_Business_Loans_Meet_Founding_Team.png" alt="American Credit Business Loans Meet Founding Team"/>
					</div>
				</div>
			</div>
		</div>

		<div style="width: 100%; background-color: white;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <div style="padding-top: 20px; font-family: Biotif; font-weight: 400; font-size: 14px;">
              Footnote
            </div>
            <div class="column">
              <ul style="margin: 0; padding-left: 15px;">
                <li style="list-style: decimal; font-family: Biotif; font-weight: 400; font-size: 14px;">Source: Commercial Finance Association Education Foundation</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
 
  },
  mounted() {
    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
	}
	
    document.title="About Us | Business Loan Company | American Credit";
    meta.content="American Credit is a fully-licensed, fin-tech, asset-based lender. We bring business lending into the digital age & empower borrowers. Apply with us today!";
    keywords.content="American Credit background, small business financing, American Credit history, American Credit";
  }
};
</script>

<style scoped lang="scss">
	@import "../assets/css/global.scss";
	@import "../assets/css/fonts.css";

	.about-us {
		min-height: 720px !important;
		.about-us-main-img {
			width: 690px !important;
			margin-top: 110px !important;
		}
	}

	.platform-for-success {
		height: 788px; 
		margin: 0; 
		padding: 0; 
		position: relative;
		.platform-for-success-content {
			position: absolute; 
			top: 90px; 
			left: calc(50vw - 720px);
			h2 {
				font-family: Biotif;
				color: #272727;
				font-size: 36px;
				font-weight: 700;
				margin-bottom: 60px;
				width: 550px;
			}
			.platform-for-success-card {
				border-radius: 10px; 
				box-shadow: 2px 4px 30px 0px rgba(236, 236, 236, 0.75); 
				height: 100%; 
				padding: 40px 50px 40px 50px; 
				background: white;
				.image-container {
					height: 150px;
					img {
						height: 100%; 
						width: auto; 
						object-fit: contain;
						margin-left: -10px;
					}
				}
				.platform-for-success-text {
					font-family: Biotif; 
					color: #505050; 
					font-size: 22px; 
					font-weight: 300; 
					line-height: 30px; 
					min-height: 120px;
					margin-bottom: 0;
				}
				.platform-for-success-read-more {
					color: #3c3c3c;
					font-size: 16px;
					font-weight: 700;
				}
			}
		}
	}

	.about-us-simple-idea {
		height: 680px !important;
	}

	.meet-founding-team {
		.meet-founding-team-box {
			height: 760px;
			.meet-founding-team-inner-left {
				padding-top: 100px;
				.user-feedback-text {
					font-family: Montserrat;
					color: #454545;
					font-size: 30px;
					font-weight: 400;
					line-height: 44px;
				}
				.user-feedback-name {
					font-size: 16px;
					line-height: 30px;
				}
				.user-feedback-button {
					button {
						display: inline-block; 
						background-color: rgb(84, 86, 255); 
						color: #ffffff; 
						font-size: 16px; 
						font-weight: 700; 
						height: 50px; 
						width: 152px; 
						border-radius: 25px;
						border: none;
					}
					p {
						display: inline-block; 
						font-size: 16px; 
						line-height: 30px; 
						margin-top: 30px;
					}
				}
			}
			.meet-founding-team-inner-right {
				img {
					height: auto; 
					width: 560px; 
					object-fit: contain; 
					margin-top: 80px; 
					margin-left:50px;
				}
			}
		}
	}

	.hover-element {
    position: relative;
  }

  .hover-element .hover-display-content {
    visibility: hidden;
    width: 360px;
    background-color: rgba(246,249,255, 0.8);
    color: #686868;
    text-align: left;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
  }

  .hover-element:hover .hover-display-content {
    visibility: visible;
  }

	@media (max-width:768px) {
		.about-us {
			min-height: 0 !important;
			.about-us-main-img {
				width: 100% !important;
    		margin-top: 0 !important;
			}
		}

		.platform-for-success {
			height: 1500px;
			.platform-for-success-content {
				left: 0;
				h2 {
					width: 80%;
				}
			}
		}

		.about-us-simple-idea {
			height: auto !important;
		}

		.meet-founding-team {
			.meet-founding-team-box {
				height: auto;
				.meet-founding-team-inner-left {
					padding-top: 50px;
					.user-feedback-text {
						font-size: 24px;
						line-height: 30px;
					}
				}
				.meet-founding-team-inner-right {
					img {
						width: 100%; 
						margin-top: 20px; 
						margin-left: 0;
						margin-bottom: 20px; 
					}
				}
			}
		}

		.hover-element .hover-display-content {
      width: auto;
      left: 0;
      right: 0;
    }
	}

</style>


// WEBPACK FOOTER //
// aboutUs.vue?44d9e4c2